import { Box } from '@material-ui/core';
import { useObserver } from 'mobx-react-lite';
import React from 'react';
import { FB, FBInput, FBWorkspaceModeOptions } from '..';
import KendoDataGrid from '../../components/KendoDataGrid/KendoDataGrid';
import { FBFontStyle } from '../styles/FBFont.styles';
import createSchema from './schema';
import useStyles from './styles';
import { DEVIATION_SERIAL_NUMBERS_KEY, FBAffectedSerialNumberProps } from './types';
import { lhrHasNoSerialNumbers } from './utils';

const FBAffectedSerialNumber: React.FunctionComponent<FBAffectedSerialNumberProps> = ({
  disabled,
  ...props
}) => {
  const classes = useStyles();
  const { workspaceState } = FB.useStores();
  const isOutput = workspaceState?.isOutput;
  const isPreviewMode = workspaceState?.mode ? [FBWorkspaceModeOptions.PREVIEW, FBWorkspaceModeOptions.FORMPREVIEW].includes(workspaceState.mode as FBWorkspaceModeOptions) : false;
  disabled = isPreviewMode || !isOutput;

  // rows saved before LHRs without serials were skipped (e.g. added by Create Deviation) are hidden too
  const dataValues = useObserver(() => (
    (workspaceState?.document?.formInput?.[DEVIATION_SERIAL_NUMBERS_KEY]
      || workspaceState?.formInputSync.get(DEVIATION_SERIAL_NUMBERS_KEY)) as Array<Record<string, unknown>> | undefined
  )?.filter((entry) => !lhrHasNoSerialNumbers(Object.keys(entry)[0])) ?? []);

  const schema = createSchema();

  return (
    <FBInput
      {...props}
      labelProps={FBFontStyle.labelProps}>
      <Box className={classes.root}>
        <KendoDataGrid
          schema={schema}
          data={dataValues}
          className={classes.grid}
        />
      </Box>
    </FBInput>
  );
};

export default FBAffectedSerialNumber;
